var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComunicacion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.500061,
    y: 0.5,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#F7F8FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 19.1667V30.8334H21.1167L19.1667 32.7834V19.1667H37.5ZM39.1667 15.8334H17.5C16.5834 15.8334 15.8334 16.5834 15.8334 17.5V40.8334L22.5 34.1667H39.1667C40.0834 34.1667 40.8334 33.4167 40.8334 32.5V17.5C40.8334 16.5834 40.0834 15.8334 39.1667 15.8334ZM47.5 22.5H44.1667V37.5H22.5V40.8334C22.5 41.75 23.25 42.5 24.1667 42.5H42.5L49.1667 49.1667V24.1667C49.1667 23.25 48.4167 22.5 47.5 22.5Z",
    fill: "#043873"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComunicacion);
export default __webpack_public_path__ + "static/media/comunicacion.56f0a57d2777c56af3d715e8f3b32b7f.svg";
export { ForwardRef as ReactComponent };